import { Component, Input } from '@angular/core';
import { ApplicationSettings } from "../core/coresettings";

@Component({
    selector: "crew-list",
    template: require('./list.component.html')
})
export class List {

    constructor() {
        // default values
        this.showSearch = true;
        this.filterBy = "Name";
        this.displayName = "Name";

        this.applicationSettings = ApplicationSettings.instance;
    }

    @Input()
    filterBy: string;

    @Input()
    items: any[];

    @Input()
    displayName: string;

    @Input()
    showSearch: boolean;

    @Input()
    detailsState: string;

    applicationSettings: ApplicationSettings;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/list.component.ts